import { Action, initialState, State } from "store/store";

export const setFonts = (state: State = initialState, { data }: Action) => {
  return {
    ...state,
    customFonts: data as any,
  };
};